/**
 * 滚动至指定dom底部
 */
export const scrollToBottom = (sDom, sTop) => {
  if (!sDom) return;

  sDom.scrollTo({
    top: sTop,
    // behavior: 'smooth'
  });
};

/**
 * 生成请求 ID，用于标识一个请求（作消息串联，每个请求使用不同的 request_id）
 */

export const generateRequestId = (length = 10) => {
  const data = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ];
  let nums = '';
  for (let i = 0; i < length; i++) {
    const r = parseInt(Math.random() * 61, 10);
    nums += data[r];
  }
  return nums + '-' + parseInt(Math.random() * 10000000000, 10);
};

export function maskAccount(account) {
  if (!account) return '';
  const len = account.length;
  if (len <= 7) return account; // 太短的账号不掩码

  const prefix = account.substring(0, 3);
  const suffix = account.substring(len - 4);
  return prefix + '****' + suffix;
}
export function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
/**
 * 将图片文件转换为Base64编码
 * @param {File} file - 图片文件对象（从input[type="file"]中获取）
 * @returns {Promise<string>} - 包含Base64编码的Promise
 */
export function imageFileToBase64(file) {
  // 检查文件是否为图片类型
  if (!file || !file.type.startsWith('image/')) {
    return Promise.reject(new Error('请选择有效的图片文件'));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // 读取文件完成时触发
    reader.onload = (event) => {
      // event.target.result 即为Base64编码字符串
      resolve(event.target.result);
    };

    // 读取文件出错时触发
    reader.onerror = () => {
      reject(new Error('文件读取失败，请重试'));
    };

    // 以Base64格式读取文件
    reader.readAsDataURL(file);
  });
}
